export const reverseDate = (date) => {
  let arr = date.split("-");
  let res = arr[2] + "-" + arr[1] + "-" + arr[0];
  return res;
};
